import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppProps } from './App';
import Folder from './Folder';
import { action } from 'mobx';
import FolderMenu from './FolderMenu';

interface FileMenuProps extends AppProps {
    currentFileIx: number;
}

const FileMenu = observer((props: FileMenuProps) => {
    const {state, styles, currentFileIx} = props;
    const currentFile = state.mboxList[currentFileIx];
    return (
        <div>
            <Folder
                state={state}
                path={''}
                fileIx={currentFileIx}
                styles={styles}
                name={currentFile.name}
                indentationLevel={0}
                hasChildren={!!(currentFile.labelMetadata?.labelTree.children && currentFile.labelMetadata?.labelTree.children.length > 0)}
                numberOfEmails={currentFile.messageData.length}
                openable={currentFile}
                iconClass={'file-icon'}
                key={state.mboxList[currentFileIx].key + '_folder'}
                warningIcon={currentFile.partiallyLoaded}
                eject={action(() => {
                    if(currentFileIx === state.messageQueryAndIxList.fileIx) {
                        // If we eject the open file, spit us out back at landing and reset the query index
                        state.updateCurrentView('landing');
                        state.messageQueryAndIxList.fileIx = 0;
                    } else if(currentFileIx < state.messageQueryAndIxList.fileIx) {
                        // If we eject an earlier element in the array than the current file, adjust the index to correspond
                        state.messageQueryAndIxList.fileIx = state.messageQueryAndIxList.fileIx - 1;
                    }

                    // This removes an element from the mboxList array in place.
                    state.mboxList.splice(currentFileIx, 1);
                })}
            />
            { currentFile.isOpen && currentFile.labelMetadata?
                currentFile.labelMetadata?.labelTree?.children?.map((e, ix) => {
                    return <FolderMenu
                        state={state}
                        styles={styles}
                        fileIx={currentFileIx}
                        parent={currentFile.labelMetadata!.labelTree}
                        currentFolderIx={ix}
                        depth={1}
                        path={''}
                        labelCounts={currentFile.labelMetadata!.labelCounts}
                        key={state.mboxList[currentFileIx].key + ix + 1}
                    />;
                }):
                ''
            }
        </div>
    );
});

export default FileMenu;